import { clevertapUserLogoutTracking } from "@/libs/clevertapTracking";
import performSignOutUpdates from "@/redux/slice/auth/actions/performSignOutUpdates";
import { SignOutPayload } from "@/redux/slice/auth/types/SignOutPayload";

export default async function authLogout(signOutActionPayload: SignOutPayload & { dispatch: any }) {
  const { apolloClient, dispatch } = signOutActionPayload;
  apolloClient.clearStore();
  clevertapUserLogoutTracking();

  Object.keys(localStorage).forEach((element: string) => {
    if (element.substring(0, 5) !== "WZRK_" && element !== "email_CT") {
      localStorage.removeItem(element);
    }
  });

  performSignOutUpdates({ dispatch });
}
